import React from 'react';
import styles from './HotelFuzzyMatchName.module.css';
import HotelAutocompleteLabel from '../HotelAutocompleteLabel/HotelAutocompleteLabel';

class HotelFuzzyMatchName extends React.Component {
  render() {
    const { name } = this.props;

    return (
      <span className={styles.nameRow}>
        <HotelAutocompleteLabel label={name} />
      </span>
    );
  }
}

export default HotelFuzzyMatchName;
